import { View } from 'react-native';
import { loadAsync } from 'expo-font';
import React, { useState, useEffect } from 'react';
import { fonts } from '../assets/images';
import { RootStoreProvider } from '../hooks/useStores';

/**
 * Components reach the store for their labels and for where the session is
 * (`rootStore.language.translate…`, `rootStore.treeNav.current`), and they do
 * it without optional chaining past the first level — so a story of any such
 * component crashes on the empty default context.
 *
 * Creating the real RootStore is not an option here: its afterCreate fetches
 * languages over the network, which a gallery should never do (and Chromatic
 * would flake on). This stand-in is deliberately inert and shaped only where
 * components read: labels fall back to the hardcoded English defaults the
 * components already carry. Add a branch when a story needs one.
 */
const storybookStore = {
  language: { translate: {}, name: { key: 'en' }, language: 'en' },
  treeNav: { current: '', content: {} },
  activity: { getActivityBySessionId: () => null, getActivity: () => null },
  responses: { responses: [] },
} as any;

interface Props {
  Story: () => JSX.Element;
}

const Setup = ({ Story }: Props) => {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const setup = async () => {
      try {
        await loadAsync({
          ...fonts,
        });
        setIsReady(true);
      } catch (error) {
        console.error(error);
      }
    };

    setup();
  }, []);

  if (isReady) {
    return (
      <RootStoreProvider value={storybookStore}>
        <View style={{ padding: 16, alignItems: 'flex-start' }}>
          <Story />
        </View>
      </RootStoreProvider>
    );
  }

  return <View />;
};

export { Setup };
